var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooerSectionLinkedlnBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00998 4.38354H0.224609V13.2659H3.00998V4.38354Z",
    fill: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5445 4.19096C10.4418 4.17812 10.3327 4.17171 10.2236 4.16529C8.66409 4.10111 7.78484 5.02529 7.47678 5.4232C7.39335 5.5323 7.35484 5.59648 7.35484 5.59648V4.40917H4.69141V13.2915H7.35484H7.47678C7.47678 12.3866 7.47678 11.4881 7.47678 10.5832C7.47678 10.0954 7.47678 9.60767 7.47678 9.11991C7.47678 8.51663 7.43185 7.87484 7.73349 7.3229C7.99021 6.86081 8.45229 6.62976 8.97214 6.62976C10.5124 6.62976 10.5445 8.02245 10.5445 8.15081C10.5445 8.15722 10.5445 8.16364 10.5445 8.16364V13.3301H13.3299V7.53469C13.3299 5.55156 12.3223 4.3835 10.5445 4.19096Z",
    fill: "#1D1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61731 3.23462C2.51052 3.23462 3.23462 2.51053 3.23462 1.61731C3.23462 0.724095 2.51052 0 1.61731 0C0.724092 0 0 0.724095 0 1.61731C0 2.51053 0.724092 3.23462 1.61731 3.23462Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooerSectionLinkedlnBgBlack);
export default __webpack_public_path__ + "static/media/fooer_section_linkedln_bg_black.8e941baa71dbc381b87b5b94b68adbfe.svg";
export { ForwardRef as ReactComponent };